(function($) {

$(document).ready(function(){
  if ($('.faq').length) {
    $('.faq__item__trigger').on('click',function(){
      var isOpen = $(this).hasClass('open');
      var faq = $(this).closest('.faq__item');
      if (isOpen) {
        faq.find('.faq__item__answer').removeClass('opened').slideUp('slow');
        // faq.find('.faq__item__answer').hide('slow');
        $(this).removeClass('open');
        $(this).text('Show Answer');
      } else {
        faq.find('.faq__item__answer').slideDown('slow',function(){
          $(this).addClass('opened');
        });
        // faq.find('.faq__item__answer').show('slow');
        $(this).addClass('open');
        $(this).text('Hide Answer');
      }    
    });
  }
});

})( jQuery );  